import React from 'react'
import './weloverunning.scss';

const WeLoveRunning = () => {
    return (
        <div>
            <div class="hero-image">
                <div class="hero-text">
                    <h1>We love <span className="yellowtext">running</span></h1>
                </div>
            </div>
        </div>
    )
}

export default WeLoveRunning
